import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useDispatch } from 'react-redux';
import { showMessage } from '~/actions';
import { showErrorMessage } from '~/domain/utils';
import { apiMethods } from '~/services/api';
import { apiMethodsConst } from '~/services/methods';

type TCreateLocumTenensError = AxiosError<{ message?: string; error?: string; title?: string }>;

/**
 * Locum-tenens request mutation. Posts the free-text request and shows the global
 * success message (which routes back to the locum screen). Errors surface through
 * the shared error helper. No reducer bridge and no loading/success suffix
 * consumers — this flow only ever drove `SHOW_MESSAGE`.
 */
export function useCreateLocumTenensMutation() {
  const dispatch = useDispatch();

  return useMutation<unknown, TCreateLocumTenensError, string>({
    mutationFn: async (text) => {
      return await apiMethods[apiMethodsConst.CREATE_LOCUM_TENENS_DENTIST_REQUEST](text);
    },
    onSuccess: () => {
      dispatch(
        showMessage({
          title: 'Request Successfully Sent!',
          message:
            'We’ve received your request. Someone from GoTu will reach out shortly with next steps.',
          route: '/dashboard/locum-tenens-dentist',
          isSuccess: true,
        }),
      );
    },
    onError: (error) => {
      showErrorMessage({ error });
    },
  });
}
